import React, { createContext, useState, useContext } from "react";

export const MarketplaceContext = createContext();

export default function MarketplaceProvider({ children }) {
  const [cnpj, setCnpj] = useState();
  const [empresa, setEmpresa] = useState();
  const [grupos, setGrupos] = useState([]);
  const [fabricantes, setFabricantes] = useState([]);
  const [estoques, setEstoques] = useState([]);
  const [gruposLoading, setGruposLoading] = useState(false);
  const [fabricantesLoading, setFabricantesLoading] = useState(false);
  const [estoquesLoading, setEstoquesLoading] = useState(false);
  const [marketplaceSelecionado, setMarketplaceSelecionado] = useState(null);
  const [marketplace, setMarketplace] = useState(null);
  const [marketplaceList, setMarketplaceList] = useState([]);
  const [marketplacesConectados, setMarketplacesConectados] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <MarketplaceContext.Provider
      value={{
        empresa,
        setEmpresa,
        grupos,
        setGrupos,
        fabricantes,
        setFabricantes,
        estoques,
        setEstoques,
        gruposLoading,
        setGruposLoading,
        fabricantesLoading,
        setFabricantesLoading,
        estoquesLoading,
        setEstoquesLoading,
        marketplaceSelecionado,
        setMarketplaceSelecionado,
        marketplace,
        setMarketplace,
        marketplaceList,
        setMarketplaceList,
        tabIndex,
        setTabIndex,
        marketplacesConectados,
        setMarketplacesConectados,
        cnpj,
        setCnpj,
      }}
    >
      {children}
    </MarketplaceContext.Provider>
  );
}

export function useCnpj() {
  const context = useContext(MarketplaceContext);
  const { cnpj, setCnpj } = context;
  return { cnpj, setCnpj };
}

export function useEmpresa() {
  const context = useContext(MarketplaceContext);
  const { empresa, setEmpresa } = context;
  return { empresa, setEmpresa };
}

export function useMarketplace() {
  const context = useContext(MarketplaceContext);
  const { marketplace, setMarketplace } = context;
  return { marketplace, setMarketplace };
}

export function useMarketplaceList() {
  const context = useContext(MarketplaceContext);
  const { marketplaceList, setMarketplaceList } = context;
  return { marketplaceList, setMarketplaceList };
}

export function useGrupos() {
  const context = useContext(MarketplaceContext);
  const { grupos, setGrupos } = context;
  return { grupos, setGrupos };
}

export function useFabricantes() {
  const context = useContext(MarketplaceContext);
  const { fabricantes, setFabricantes } = context;
  return { fabricantes, setFabricantes };
}

export function useEstoques() {
  const context = useContext(MarketplaceContext);
  const { estoques, setEstoques } = context;
  return { estoques, setEstoques };
}

export function useGruposLoading() {
  const context = useContext(MarketplaceContext);
  const { gruposLoading, setGruposLoading } = context;
  return { gruposLoading, setGruposLoading };
}

export function useFabricantesLoading() {
  const context = useContext(MarketplaceContext);
  const { fabricantesLoading, setFabricantesLoading } = context;
  return { fabricantesLoading, setFabricantesLoading };
}

export function useEstoquesLoading() {
  const context = useContext(MarketplaceContext);
  const { estoquesLoading, setEstoquesLoading } = context;
  return { estoquesLoading, setEstoquesLoading };
}

export function useMarketplaceSelecionado() {
  const context = useContext(MarketplaceContext);
  const { marketplaceSelecionado, setMarketplaceSelecionado } = context;
  return { marketplaceSelecionado, setMarketplaceSelecionado };
}

export function useTabIndex() {
  const context = useContext(MarketplaceContext);
  const { tabIndex, setTabIndex } = context;
  return { tabIndex, setTabIndex };
}

export function useMarketplacesConectados() {
  const context = useContext(MarketplaceContext);
  const { marketplacesConectados, setMarketplacesConectados } = context;
  return { marketplacesConectados, setMarketplacesConectados };
}
